// Ukrainian translations
const uk = {
  header: {
    news: "НОВИНИ",
    servers: "СЕРВЕРИ",
    faq: "ПИТАННЯ",
    market: "МАРКЕТ",
  },
  footer: {
    navigation: "Навігація",
    information: "Інформація",
    home: "Головна",
    news: "Новини",
    market: "Маркет",
    faq: "Питання",
    userAgreement: "Угода користувача",
    rules: "Правила",
    privacyPolicy: "Політика конфіденційності",
    disclaimer:
      "S.T.A.L.K.E.R.S Reborn не є афілійованим чи схваленим GSC Game World або будь-яким іншим правовласником. Усі торгові марки належать їхнім власникам.",
    allRightsReserved: "Усі права захищено.",
  },
  main: {
    crossPerimeter: "ПЕРЕТНИ ПЕРИМЕТР",
    exploreZone: "Досліджуй Зону",
    leaderboards: "Таблиці лідерів",
    online: "ОНЛАЙН",
    offline: "ОФЛАЙН",
  },
  news: {
    title: "Новини",
    olderPosts: "Попередні публікації",
    stayInformed: "Будьте в курсі останніх подій",
    loadMore: "Показати більше",
    noPosts: "Поки що немає публікацій",
    networkErrorTitle: "Не вдалося завантажити новини",
    networkErrorText:
      "Спробуйте оновити сторінку та завантажити стрічку новин ще раз.",
    createPost: "Створити публікацію",
    deleteConfirm: "Видалити цю публікацію?",
  },
  servers: {
    title: "Сервери",
    subtitle: "Підключайся до наших серверів і вирушай у Зону",
    online: "Онлайн",
    offline: "Офлайн",
    noServers: "Наразі сервери недоступні",
    networkErrorTitle: "Не вдалося завантажити сервери",
    networkErrorText:
      "Спробуйте оновити сторінку та завантажити статус серверів ще раз.",
    connect: "Підключитися",
    copied: "Скопійовано!",
    copyIp: "Скопіювати IP",
    noIpAvailable: "IP недоступна",
    notAvailable: "Недоступно",
    connectCopyIp: "Підключитися (копіювати IP)",
    activity24h: "Активність за 24 год",
    peak24h: "Пік онлайну (24 год)",
    avg24h: "Середній онлайн (24 год)",
    uptime24h: "Час роботи (24 год)",
    noDataAvailable: "Дані недоступні",
    onlineNow: "зараз онлайн",
    peakOnline: "максимум онлайну",
    peakAllTime: "рекорд онлайну",
    serversOnline: "серверів онлайн",
    serverStatistics: "Статистика серверів",
  },
  market: {
    title: "Маркет",
    subtitle: "Придбай спорядження для своєї подорожі Зоною",
    signInPrompt: "Увійдіть, щоб почати покупки",
    networkErrorTitle: "Не вдалося завантажити маркет",
    networkErrorText:
      "Спробуйте оновити сторінку та завантажити каталог ще раз.",
    purchaseComplete: "Покупку завершено!",
    purchaseFailed: "Помилка під час покупки",
    purchaseMessage: "Ваші товари успішно придбано.",
    totalCost: "Загальна вартість",
    newBalance: "Новий баланс",
    itemsPurchased: "Придбані товари",
    processing: "Обробка...",
    shoppingCart: "Кошик",
    cartSubtitle: "Перевір свої товари перед оформленням.",
    closeCart: "Закрити кошик",
    cartEmpty: "Ваш кошик порожній",
    addItemsPrompt: "Додайте товари, щоб розпочати!",
    items: "Товари",
    itemLabel: "Товар",
    unitPrice: "Ціна за од.",
    quantity: "Кількість",
    itemTotal: "Сума",
    cartStage: "Кошик",
    purchaseStage: "Покупка",
    receiptStage: "Чек",
    nextStep: "Наступний крок",
    total: "Разом",
    subtotal: "Проміжна сума",
    discount: "Знижка",
    checkout: "Оформити замовлення",
    continueShopping: "Продовжити покупки",
    promoCode: "Промокод",
    applyPromo: "Застосувати",
    promoUnavailable: "Промокоди поки недоступні",
    securePayment: "Безпечна оплата через Steam.",
    dataProtected: "Ваші дані під захистом.",
    allSalesFinal: "Усі покупки є остаточними та не підлягають поверненню.",
    needHelp: "Потрібна допомога?",
    clearCart: "Очистити кошик",
    clearCartMobile: "Очистити",
    clearCartConfirm: "Ви впевнені, що хочете очистити кошик?",
    removeItemFromCart: "Видалити товар з кошика",
    removeSelected: "Видалити вибране",
    itemsSelected: "товарів вибрано",
    selectItem: "Вибрати товар",
    decreaseQuantity: "Зменшити кількість",
    increaseQuantity: "Збільшити кількість",
    categoryArmor: "Броня",
    categoryWeapons: "Зброя",
    categoryFood: "Їжа та напої",
    marketItemLabel: "Товар маркету",
    purchasedItems: "Придбані товари",
    noItemsTitle: "Товарів не знайдено",
    noItemsText: "Спробуйте змінити фільтри або перевірте пізніше.",
    loadMore: "Показати більше товарів",
    loadingMore: "Завантажуємо більше товарів...",
  },
  faq: {
    title: "Питання",
    subtitle: "Часті запитання",
    mainQuestions: "Основні питання",
    clarifications: "Деталі та уточнення",
    noQuestions: "Питань поки немає.",
    noClarifications: "Уточнень поки немає.",
  },
  common: {
    loginWithSteam: "УВІЙТИ ЧЕРЕЗ STEAM",
    voteForServer: "Голосувати за сервер",
    donate: "Підтримати",
    exit: "Вийти",
    buyNow: "КУПИТИ ЗАРАЗ",
    getLauncher: "ЗАВАНТАЖИТИ ЛОНЧЕР",
    viewServers: "ПЕРЕГЛЯНУТИ СЕРВЕРИ",
    getGame: "ОТРИМАТИ ГРУ",
    yes: "Так",
    no: "Ні",
    close: "Закрити",
    closeModal: "Закрити вікно",
    error: "Помилка",
    retry: "Спробувати ще раз",
  },
  leaderboard: {
    zonePresence: "ЧАС У ЗОНІ",
    moneyEarned: "ЗАРОБЛЕНО",
    legendsOfZone: "ЛЕГЕНДИ ЗОНИ",
    hours: " год.",
  },
  steps: {
    getGame: {
      title: "ОТРИМАЙ ГРУ",
      description:
        "Новачок у DayZ? Придбай гру в Steam і підготуйся. Запусти один раз, щоб створити конфігурації - і ти готовий зануритися в Зону.",
    },
    installLauncher: {
      title: "ВСТАНОВИ ЛОНЧЕР",
      description:
        "Інсталюй DZSALauncher для зручного керування модами. Він сам знайде, завантажить і оновить усе - синхронізація в один клік.",
    },
    browseServers: {
      title: "ОБЕРИ СЕРВЕР",
      description:
        "Зазирни в список серверів і обери, куди вирушиш. Ознайомся з онлайн-статистикою та пінгом одразу - приєднуйся одним кліком через DZSALauncher.",
    },
  },
  userPanel: {
    voteForServer: "Голосувати за сервер",
    donate: "Підтримати",
    exit: "Вийти",
    openUserMenu: "Відкрити меню користувача",
    userInfo: "Профіль користувача",
  },
  language: {
    english: "English",
    ukrainian: "Українська",
  },
};

export default uk;
